import React, { Component } from "react";

import "./festival.css";

function Festivals() {
  return (
    <>
      <div className="content">
        <div className="fest-1">
          <h3> Indian Festivals </h3>
          <img src="https://cdn4.dogonews.com/images/12d97175-ec7a-4dc6-be6f-05c8ea2343d3/diwali-celebration-750x430.jpg" />
          <p>
            {" "}
            India is a land of festivals and fairs. Virtually celebrating each
            day of the year, there are more festivals celebrated in India than
            anywhere else in the world. Each festival pertains to different
            occasions, some welcome the seasons of the year, the harvest, the
            rains, or the full moon. Others celebrate religious occasions, the
            birthdays of divine beings and saints, or the advent of the New
            Year. A number of these festivals are common to most parts of India.
            However, they may be called by different names in various parts of
            the country or may be celebrated in a different fashion. Some of the
            festivals celebrated all over India are mentioned below. However,
            this section is still under enhancement.
          </p>
        </div>
        <div className="fest-1">
          <h3> Navratri </h3>
          <img src="https://top10tale.com/wp-content/uploads/2018/10/Navratri-festival-is-celebrated-in-the-month-of-October.jpg" />
          <p>
            Navaratri is a Hindu festival that spans nine nights (and ten days)
            and is celebrated every year in the autumn. It is observed for
            different reasons and celebrated differently in various parts of the
            Hindu Indian cultural sphere Theoretically, there are four seasonal
            Navaratri. However, in practice, it is the post-monsoon autumn
            festival called Sharada Navaratri that is the most observed in the
            honour of the divine feminine Devi (Durga). The festival is
            celebrated in the bright half of the Hindu calendar month Ashvin,
            which typically falls in the Gregorian months of September and
            October{" "}
          </p>
        </div>
        <div className="fest-1">
          <h3> Diwali </h3>
          <img src="https://www.indiaonlinepages.com/festivals/diwali/gifs/diwali-festival.jpg" />
          <p>
            Diwali is a festival of lights and one of the major festivals
            celebrated by Hindus, Jains, Sikhs and some Buddhists, notably Newar
            Buddhists. The festival usually lasts five days and is celebrated
            during the Hindu lunisolar month Kartika (between mid-October and
            mid-November. One of the most popular festivals of
            Hinduism, Diwali symbolizes the spiritual "victory of light over
            darkness, good over evil, and knowledge over
            ignorance. The festival is widely associated with
            Lakshmi, goddess of prosperity, with many other regional traditions
            connecting the holiday to Sita and Rama, Vishnu, Krishna, Yama,
            Yami, Durga, Kali, Hanuman, Ganesha, Kubera, Dhanvantari, or
            Vishvakarman. Furthermore, it is, in some regions, a celebration of
            the day Lord Rama returned to his kingdom Ayodhya with his wife Sita
            and his brother Lakshmana after defeating Ravana in Lanka and
            serving 14 years of exile.{" "}
          </p>
        </div>
        <div className="fest-1">
          <h3> Raksha Bandhan </h3>
          <img src="https://assets.sentinelassam.com/h-upload/2021/08/22/249944-rak.webp?w=400&dpr=2.6" />
          <p>
            Celebrated on the full-moon day of the Hindu month of Sravana
            (July/August), this festival celebrates the love of a brother for
            his sister. On this day, sisters tie rakhi on the wrists of their
            brothers to protect them against evil influences, and pray for their
            long life and happiness. They in turn, give a gift which is a
            promise that they will protect their sisters from any harm. Within
            these Rakhis reside sacred feelings and well wishes. This festival
            is mostly celebrated in North India.{" "}
          </p>
        </div>
        <div className="fest-1">
          <h3> Holi </h3>
          <img src="https://i.ndtvimg.com/i/2018-01/holi_650x400_51516870691.jpg" />
          <p>
            The arrival of spring in India is marked with the revelers covered
            in bright colored powder as they celebrate Holi. Usually falling in
            March, the festival of Holi brings with it the celebrations where
            the merrymakers wish each other Happy Holi by applying ‘gulal’ or
            colored powder on each other’s cheeks. Savories, dance, music, and
            food are the other highlights of this festival.{" "}
          </p>
        </div>
        <div className="fest-1">
          <h3>Ganesh Chaturthi </h3>
          <img src="https://resize.indiatvnews.com/en/resize/newbucket/715_-/2020/07/ganesh-chaturthi-1594485058.jpg" />
          <p>
            Celebrated with much fervor and excitement, the festival of Ganesh
            Chaturthi revels the homecoming of Lord Ganesh. One of the most
            colorful and exciting 10 day-long celebrations of the Ganesh
            Chaturthi is initiated with installing the idol of Lord Ganesh at
            home to bless the house, and its members with happiness and
            prosperity. At the end of the ten days, this idol is taken with much
            pomp and show to be immersed in water.{" "}
          </p>
        </div>
        <div className="fest-1">
          <h3>Christmas </h3>
          <img src="https://i.ytimg.com/vi/UmBuWU2YsBs/maxresdefault.jpg" />
          <p>
            Among the most famous festivals of India, Christmas is celebrated on
            the 25th of December each year. Celebrated to commemorate the birth
            of Jesus Christ, this festival is the time for religious and
            cultural celebrations for Christians. Usually celebrated by
            decorating the Christmas tree and exchanging gifts, this festival is
            known for merrymaking.{" "}
          </p>
        </div>
      </div>
    </>
  );
}

export default Festivals;
